import React from "react";
import { Reveal, Overline } from "../components/site/Reveal";
import { CLIENTS } from "../data/content";

export const ClientLogos = () => (
  <section id="clients" className="relative bg-white py-24 sm:py-28" data-testid="clients-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-3xl">
        <Reveal><Overline>Experience Across Global Leaders</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
            Trusted experience with <span className="text-gradient-emerald">world-class organisations</span>.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-charcoal/70">
            Over his career, Anthony Onwodi has delivered operational, supply-chain and transformation work with — and for —
            some of the world's most respected organisations, including Shell Petroleum SPDC, P&amp;G, Siemens Healthineers,
            Johnson Matthey, Ball Corporation, Essex County Council, Maple Leaf Foods and Svensk Direktreklam, to mention a few.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {CLIENTS.map((c, i) => (
          <Reveal key={c.name} delay={(i % 4) * 0.08}>
            <div data-testid={`client-logo-${i}`}
              className="group flex h-full items-center gap-4 rounded-2xl border border-black/5 bg-bg-light p-5 transition-[transform,border-color] duration-500 hover:-translate-y-1 hover:border-gold/40">
              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-emerald-base font-serif text-lg font-semibold text-gold-light transition-colors duration-500 group-hover:bg-gold group-hover:text-emerald-darkest">
                {c.monogram}
              </div>
              <span className="text-sm font-semibold leading-tight text-charcoal/80 transition-colors duration-300 group-hover:text-emerald-base">
                {c.name}
              </span>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-8 text-sm italic text-charcoal/40">
          Company names are referenced to reflect professional experience. All trademarks and logos are the property of their respective owners.
        </p>
      </Reveal>
    </div>
  </section>
);
